<div
  class="tw-flex tw-h-full tw-w-[90vw] sm:tw-w-full tw-gap-6 tw-bg-tealgray-50 tw-rounded-b-xl tw-pb-10"
>
  <div class="tw-w-2/5 tw-bg-gray-100 tw-p-4 tw-rounded tw-shadow">
    <span class="tw-h-96 tw-flex tw-items-center tw-justify-center tw-text-gray-400">
      {{ "viewFullPage" | i18n }}
    </span>
  </div>

  <div class="tw-w-3/5 tw-flex tw-flex-col tw-gap-4 tw-pr-8 tw-pt-4">
    <div class="tw-flex tw-items-center tw-justify-between tw-text-sm tw-w-full">
      <span class="tw-text-base tw-text-dt-text-secondary tw-uppercase">{{
        "linkToAccounts" | i18n
      }}</span>

      <div
        class="tw-flex tw-items-center tw-gap-2 tw-bg-dt-surface-elevated tw-p-5 tw-py-2 tw-rounded-lg tw-text-dt-text-headings"
      >
        <span>{{ "fileDetails" | i18n }}</span>
        <span>&gt;</span>
        <span class="tw-text-dt-text-action tw-underline">{{ "linkToAccounts" | i18n }}</span>
        <span>&gt;</span>
        <span>{{ "addTransaction" | i18n }}</span>
      </div>
    </div>

    <!-- Linked Accounts -->
    <div
      *ngFor="let acc of linkedAccounts"
      class="tw-items-center tw-justify-between tw-bg-dt-surface-elevated tw-px-6 tw-py-4 tw-rounded-lg"
    >
      <span class="tw-text-dt-text-headings tw-font-medium">{{ acc.name }}</span>
      <div class="tw-text-sm tw-text-dt-text-disabled tw-mt-3">
        <span>{{ "opening" | i18n }}</span>
        <span class="tw-text-dt-text-headings tw-mx-1">
          {{ openingBalance(acc.id)?.bankImportedBalance | number: "1.2-2" }}
          {{ acc.currency }}
        </span>
        <span class="tw-mr-1">,</span>
        <span>{{ "closing" | i18n }}</span>
        <span class="tw-text-dt-text-headings tw-mx-1">
          {{ closingBalance(acc.id)?.bankImportedBalance | number: "1.2-2" }}
          {{ acc.currency }}
        </span>
      </div>
    </div>

    @if (showLinkAccount) {
      <div
        class="tw-flex tw-flex-col tw-border tw-border-neutral-100 tw-bg-dt-surface-elevated tw-p-4 tw-rounded-lg"
      >
        <!-- Statement Account -->
        <button
          class="tw-self-end tw-bg-dt-surface-card tw-px-1.5 tw-py-2 tw-border tw-border-dt-border-error tw-rounded-lg tw-text-dt-text-error tw-font-medium tw-text-xs"
          (click)="removeLinkAccount()"
        >
          {{ "remove" | i18n }}
        </button>
        <span class="tw-text-dt-text-headings tw-font-medium">{{ "statementAccount" | i18n }}</span>
        <app-dropdown-select
          class="tw-mt-1.5 tw-mb-3"
          [placeholder]="'selectExistingAccount' | i18n"
          [selectedOption]="selectedAccount?.name"
          [options]="accountOptions"
          (optionSelected)="accountSelected($event)"
        >
        </app-dropdown-select>

        <!-- Statement Balance -->
        <div class="tw-flex tw-items-center tw-justify-between tw-w-full tw-font-medium">
          <span class="tw-text-dt-text-headings tw-text-base">{{ "statementBalance" | i18n }}</span>
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-1.5">
            <span class="tw-text-dt-text-secondary tw-text-sm">{{ "changeCurrency" | i18n }}</span>
            <icon [name]="'coins-swap'" [size]="3"></icon>
          </div>
        </div>
        <div class="tw-flex tw-w-full tw-justify-around tw-gap-4 tw-mt-1.5">
          <!-- Opening -->
          <div
            class="tw-w-1/2 left-round-border tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-dt-surface-card tw-px-6 tw-py-3 tw-shadow-inner sm:tw-mt-7 sm:tw-flex-auto"
          >
            <span class="sm:tw--ml-[20px] sm:tw--mt-[65px] sm:tw-w-0">{{ "opening" | i18n }}</span>
            <input
              type="number"
              placeholder="0.00"
              class="tw-w-full tw-border-0 tw-text-left focus:tw-border-none focus:tw-outline-none"
              [(ngModel)]="openingBalanceInput"
            />
            <span class="tw-uppercase tw-text-dt-text-disabled">{{ accountCurrency }}</span>
          </div>
          <!-- Closing -->
          <div
            class="tw-w-1/2 right-round-border tw-flex tw-items-center tw-justify-between tw-gap-3 tw-bg-dt-surface-card tw-px-6 tw-py-3 tw-shadow-inner sm:tw-mt-7 sm:tw-flex-auto"
          >
            <span class="sm:tw--ml-[20px] sm:tw--mt-[65px] sm:tw-w-0">{{ "closing" | i18n }}</span>
            <input
              type="number"
              placeholder="0.00"
              class="tw-w-full tw-border-0 tw-text-left focus:tw-border-none focus:tw-outline-none"
              [(ngModel)]="closingBalanceInput"
            />
            <span class="tw-uppercase tw-text-dt-text-disabled">{{ accountCurrency }}</span>
          </div>
        </div>
      </div>
    }

    <div class="tw-w-full tw-flex tw-justify-end">
      <button
        class="tw-text-dt-text-headings tw-text-sm tw-font-medium tw-inline-flex tw-px-3 tw-py-1 tw-bg-dt-surface-card tw-rounded-lg tw-border tw-border-neutral-100 tw-gap-2 tw-items-center"
        (click)="linkAnotherAccount()"
      >
        {{ "linkAnotherAccount" | i18n }}
        <icon [name]="'add'" [size]="3" [currentColor]="'black'"></icon>
      </button>
    </div>

    <div class="tw-flex tw-self-end tw-items-center tw-justify-between tw-gap-4 tw-mt-auto">
      <app-gloss-button [options]="draftOptions"></app-gloss-button>
      <app-gloss-button [options]="saveOptions"></app-gloss-button>
    </div>
  </div>
</div>
